export default __webpack_public_path__ + "static/ATA-31f10c1e936854e859f7eda05ad540ca.svg";